/**
 * The delayed automatic diagnosis of an incident (D22, ADR-0039): when it is
 * due, and whether that time has passed (a backlog being caught up, or a retry
 * after a failure), or null when nothing is scheduled or a diagnosis exists.
 */
export function getDiagnosisSchedule(
  diagnostics: { autoDiagnosisDueAt?: string | null },
  hasPersistedDiagnosis: boolean,
  now: Date = new Date(),
): { dueAt: Date; overdue: boolean } | null {
  if (hasPersistedDiagnosis || !diagnostics.autoDiagnosisDueAt) return null;
  const dueAt = new Date(diagnostics.autoDiagnosisDueAt);
  if (Number.isNaN(dueAt.getTime())) return null;
  return { dueAt, overdue: dueAt.getTime() <= now.getTime() };
}
